import Swiper from 'swiper';
import 'swiper_dir/css/swiper.min.css'

const swiper = new Swiper('.js-slider1', {
  slidesPerView: 'auto',
  centeredSlides : true,
  loop: true,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    600: {
      slidesPerView: 1
    }
  }
});


const swiper2 = new Swiper('.js-slider2', {
  slidesPerView: 1,
  effect: 'slide',
  on: {
    init: function () {
      $(".js-slider2-thumbnail li").on('click', function(){
        swiper2.slideTo(($(this).index() + 1), 500);
      });
    },
  },
  loop: true,
  speed: 700,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: '.js-slider2-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.js-slider2-next',
    prevEl: '.js-slider2-prev',
  }
});